<script>
// import Translations from "./insert-me-to-translate.vue";

import { inject } from '@vue/composition-api'

export default {
    setup(_, ctx) {
        const trans = {
            "title_convertion_done": gettext("Conversion done"),
            "credits": gettext("Credits"),
            "convert_more": gettext("Convert more Vouchers")
        }

        const voucherCredits = inject('voucherCredits')
        const voucher = inject('voucher')
        const status = inject('status')
        const status_checked = inject('status_checked')
        const status_insert = inject('status_insert')


        const redeemMoreVoucher = () => {
            voucher.value = null
            status.value = status_insert
            voucher.validated = true
        }

        return {
            trans,
            voucher,
            voucherCredits,
            status,
            status_checked,
            redeemMoreVoucher,
            voucherCredits
        }
    },
    mounted() {
        this.cookies = this.$cookies
    }
}
</script>

<template>
    <div>
        <div class="col">
            <h5 class="d-flex justify-content-between align-items-center">
                <div class="text-success"><i class="fa fa-check-circle text-success" aria-hidden="true"></i>
                    {{trans.title_convertion_done}}:<br> <b>{{ voucherCredits }} {{trans.credits}}</b>
                </div>
            </h5>
        </div>
        <div class="col mt-4">
            <a @click="redeemMoreVoucher">{{ trans.convert_more }}</a>
        </div>
    </div>
</template>

